import { windowWidth } from './utils';

const headerHoverPopups = {
  accountBtn: document.getElementById('jsUserBtn') as HTMLElement,
  accountWrap: document.getElementById('jsUserWrap') as HTMLElement,
  cartBtn: document.getElementById('jsCartBtn') as HTMLElement,
  cartWrap: document.getElementById('jsCartWrap') as HTMLElement,

  init() {
    if (windowWidth > 1200) {
      this.setHoverState();
      this.removeHoverState();
    }
  },

  setHoverState() {
    this.accountBtn.addEventListener(
      'mouseenter',
      this.handleAccountHover.bind(this),
    );
    this.cartBtn.addEventListener(
      'mouseenter',
      this.handleCartHover.bind(this),
    );
  },

  handleAccountHover() {
    this.accountBtn.classList.add('activeClass');
    this.cartBtn.classList.remove('activeClass');
    this.accountWrap.classList.add('activeClass');
    this.cartWrap.classList.remove('activeClass');
  },

  handleCartHover() {
    this.cartBtn.classList.add('activeClass');
    this.accountBtn.classList.remove('activeClass');
    this.cartWrap.classList.add('activeClass');
    this.accountWrap.classList.remove('activeClass');
  },

  removeHoverState() {
    window.addEventListener('mouseover', this.handleMouseOut.bind(this));
  },

  handleMouseOut(e) {
    const target = e.target as HTMLElement;

    if (!this.isHoveredElement(target)) {
      this.cartBtn.classList.remove('activeClass');
      this.accountBtn.classList.remove('activeClass');
      this.accountWrap.classList.remove('activeClass');
      this.cartWrap.classList.remove('activeClass');
    }
  },

  isHoveredElement(target: HTMLElement): boolean {
    return [
      this.accountBtn,
      this.accountWrap,
      this.cartBtn,
      this.cartWrap,
    ].some((element) => element === target || element.contains(target));
  },
};

export default headerHoverPopups;
